import { call, put, takeLatest, apply } from 'redux-saga/effects'
import { FETCH_SUGGESTIONS } from './constants'
import { fetchSuggestions } from './actions'
import { client as getClient, buildSuggestionQuery } from './helpers'
import { getCustomer } from 'helpers'

function* fetchSuggestionsWorker(action) {
  const response = yield call(getSuggestions, action.query)
  const results = response.aggregations.headings.buckets.map((item) => item.key)
  yield put(fetchSuggestions.success(results))
}

function* getSuggestions(query) {
  const customer = getCustomer().toLowerCase()

  // send first query without fuzziness
  const client = yield call(getClient, 'search-type-ahead')
  let results = yield apply(client, 'search', [
    {
      index: customer,
      body: buildSuggestionQuery(query)
    }
  ])

  if (results.aggregations.headings.buckets.length !== 0) {
    return results
  }

  // if no results were returned execute second query with fuzziness
  results = yield apply(client, 'search', [
    {
      index: customer,
      body: buildSuggestionQuery(query, { fuzziness: true })
    }
  ])

  return results
}

export default function* watcher() {
  yield takeLatest(FETCH_SUGGESTIONS.REQUEST, fetchSuggestionsWorker)
}
